import * as React from 'react';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { FieldError } from 'react-hook-form';
import DynamicSelect from '../../../../Components/Base/DynamicSelect/DynamicSelect';
import { useState } from 'react';
import { searchPatientsByUserNumber } from '../../../Patient/Services/patient.service';
import CentralEvidenceSearchFieldItem from './CentralEvidenceSearchFieldItem';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	placeholder?: string;
	onSelect: (value: { id: string; number?: string }) => void;
}

export interface CentralEvidenceSearchFieldValue extends SelectValue {
	item: any;
}

const CentralEvidenceSearchField: React.FC<Props> = props => {
	const { value, onChange, onSelect } = props;
	const [defaultValue, setDefaultValue] = useState<SelectValue | undefined>(
		value,
	);

	const handleChange = (val: any) => {
		setDefaultValue(val);
		onChange?.(val);
	};

	const handleSearchItem = async (
		searchInput: string,
	): Promise<SelectValue[]> => {
		const items: CentralEvidenceSearchFieldValue[] = [];

		const data = await searchPatientsByUserNumber(searchInput.replace('/', ''));
		for (const workplacePatient of data || []) {
			items.push({
				value: workplacePatient?.number,
				label: workplacePatient?.number,
				item: workplacePatient,
			});
		}

		return items;
	};

	return (
		<DynamicSelect
			searchItems={handleSearchItem}
			{...props}
			onChange={handleChange}
			value={defaultValue?.label ? defaultValue : value}
			ItemTemplate={(item: any) => (
				<CentralEvidenceSearchFieldItem item={item} selectOption={onSelect} />
			)}
		/>
	);
};

export default CentralEvidenceSearchField;
